import { getMeasurementModule } from "../../../utlis/measurementModules";

const STORAGE_KEY = "measurementUploadSession";

export const MAX_MEASUREMENT_SESSION_TESTS = 2;

const currentPersonId = () => {
  try {
    const people = JSON.parse(sessionStorage.getItem("userList") || "[]");
    return people[sessionStorage.getItem("userIndex")]?.id || null;
  } catch {
    return null;
  }
};

const normalizeModule = (module) => ({
  moduleId: Number(module.moduleId),
  moduleName: module.moduleName,
  description: module.description,
  lastTestTaken: module.lastTestTaken,
  totalTest: module.totalTest,
  isReportAvailable: module.isReportAvailable,
  reportURL: module.reportURL,
  isOperationAllowed: module.isOperationAllowed,
});

export const readMeasurementSession = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (!parsed || !Array.isArray(parsed.queue)) return null;
    if (
      parsed.personId &&
      String(parsed.personId) !== String(currentPersonId())
    ) {
      clearMeasurementSession();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const writeMeasurementSession = (session) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearMeasurementSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

export const startMeasurementSession = (
  modules,
  personId = currentPersonId(),
) => {
  const unique = new Map();
  (Array.isArray(modules) ? modules : []).forEach((module) => {
    if (
      !module ||
      !getMeasurementModule(module.moduleId) ||
      module.isOperationAllowed === false
    )
      return;
    const normalized = normalizeModule(module);
    if (!unique.has(normalized.moduleId))
      unique.set(normalized.moduleId, normalized);
  });
  const queue = [...unique.values()]
    .sort(
      (a, b) =>
        getMeasurementModule(a.moduleId).captureRank -
        getMeasurementModule(b.moduleId).captureRank,
    )
    .slice(0, MAX_MEASUREMENT_SESSION_TESTS);

  if (!queue.length) {
    clearMeasurementSession();
    return null;
  }

  const session = {
    queue,
    personId,
    index: 0,
    completedModuleIds: [],
    startedAt: new Date().toISOString(),
  };
  writeMeasurementSession(session);
  return session;
};

export const getCurrentSessionModule = (session = readMeasurementSession()) =>
  session?.queue?.[session.index] || null;

export const getNextSessionModule = (session = readMeasurementSession()) =>
  session?.queue?.[session.index + 1] || null;

export const getSessionModuleRoute = (moduleId) =>
  getMeasurementModule(moduleId)?.route;

export const prepareModuleForUpload = (module) => {
  if (!module) return;
  sessionStorage.setItem("romStatus", "noenter");
  sessionStorage.setItem("testDescription", JSON.stringify(module));
  sessionStorage.setItem("fromUpload", JSON.stringify(module));
};

export const completeCurrentSessionModule = () => {
  const session = readMeasurementSession();
  const current = getCurrentSessionModule(session);
  if (!session || !current) {
    return { session: null, current: null, next: null, isComplete: true };
  }

  const completedModuleIds = Array.from(
    new Set([...(session.completedModuleIds || []), current.moduleId]),
  );
  const nextIndex = session.index + 1;
  const next = session.queue[nextIndex] || null;

  if (!next) {
    clearMeasurementSession();
    return { session: null, current, next: null, isComplete: true };
  }

  const updated = {
    ...session,
    index: nextIndex,
    completedModuleIds,
  };
  writeMeasurementSession(updated);
  return { session: updated, current, next, isComplete: false };
};
